var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"layout-section -no-top"},[_c('div',{staticClass:"rte",domProps:{"innerHTML":_vm._s(_vm.wp.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }